export default __webpack_public_path__ + "images/38d59048f528cd7cbd5ced5ecf07c538-fleet-texto.svg";